import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./PrivateRoute.js";
import { Navigate } from "react-router-dom";

import AuthRouter from "./AuthRouter.js";
import LoginRouter from "./LoginRouter.jsx";
import TermsAndConditions from "../Components/Terms&Conditions/Terms&Conditions.jsx";
import PrivacyPolicy from "../Components/PrivacyPolicy/PrivacyPolicy.jsx";
import Rules from "../Components/Rules/Rules.jsx";
import ContactUs from "../Components/ContactUs/ContactUs.jsx";
import Guest from "../_V2/Pages/Dashboard/Guest";


import withGTM from "../hoc/withGTM.js";

import {
  Landing,
  V2Signup,
  V2Login,
  Leagues,
  EmailVerification,
  V2ForgotPassword,
  V2ResetPassword,
  V2Dashboard,
  PickDetail
} from "./_V2RouterPath.js";
import RoundToJoin from "../_V2/Pages/RoundToJoin/RoundToJoin.jsx";

//My Wallet Imports
import MyWallet from "../_V2/Pages/MyWallet/MyWallet.jsx";
import MyProfile from "../_V2/Pages/MyProfile.jsx";
import Help from "../_V2/Pages/Help.jsx";
import FaqQuestionAnswers from "../_V2/Components/FaqQuestionAnswers.jsx";
import Health from "../_V2/Pages/Heath.jsx";
import HowToPlayHome from "../_V2/Pages/HowToPlayHome.jsx";

/*NEW V2 Routers*/

const ContactUsWithGTM = withGTM(ContactUs);
const TermsAndConditionsWithGTM = withGTM(TermsAndConditions);
const RulesWithGTM = withGTM(Rules);
const LandingWithGTM = withGTM(Landing);
const PrivacyPolicyWithGTM = withGTM(PrivacyPolicy);

function MainRouter(isAuthenticated) {
  const isAuthUser = localStorage.getItem("isAuthUser");
  return (
    <div>
      <Router>
        <Routes>
          {/* V2 Router */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route
            path="/health"
            element={
              <LoginRouter
                element={Health}
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route
            path="/login"
            element={
              <LoginRouter
                element={V2Login}
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route
            path="/signup"
            element={
              <LoginRouter
                element={V2Signup}
                isAuthenticated={isAuthenticated}
              />
            }
          />

          <Route
            path="/league/:email"
            element={
              <LoginRouter
                element={Leagues}
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route path="/guest" element={<Guest />} />

          <Route
            path="/emailVerification/:email"
            element={
              <LoginRouter
                element={EmailVerification}
                isAuthenticated={isAuthenticated}
              />
            }
          />

          <Route
            path="/forgotPassword/"
            element={
              <LoginRouter
                element={V2ForgotPassword}
                isAuthenticated={isAuthenticated}
              />
            }
          />

          <Route
            path="/resetPassword/:email"
            element={
              <LoginRouter
                element={V2ResetPassword}
                isAuthenticated={isAuthenticated}
              />
            }
          />

          <Route path="/rounds" element={<RoundToJoin />} />
          
          <Route
            path="/v2-pickDetail"
            element={
              <PrivateRoute
                element={PickDetail}
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route
            path="/wallet"
            element={
              <PrivateRoute
                element={MyWallet}
                isAuthenticated={isAuthenticated}
              />
            }
          />  
          {/* V2 Router */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/" element={<LandingWithGTM />} />
          <Route path="/termsAndConditions" element={<TermsAndConditionsWithGTM />} />
          <Route path="/contactUs" element={<ContactUsWithGTM />} />
          <Route path="/rules" element={<RulesWithGTM />} />

          <Route path="/dashboard" element={<V2Dashboard />} />
          <Route path="/profile" element={<MyProfile />} />
          <Route path="/how-to-play" element={<HowToPlayHome />} />
          <Route path="/help" element={<Help />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicyWithGTM />} />
          <Route path="/faqQuestions" element={<FaqQuestionAnswers />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute
                element={V2Dashboard}
                isAuthenticated={isAuthenticated}
              />
            }
          />
            <Route
            path="/dashboard/paymentSucc"
            element={
              <PrivateRoute
                element={V2Dashboard}
                isAuthenticated={isAuthenticated}
              />
            }
          />
            <Route
            path="/dashboard/paymentFailed"
            element={
              <PrivateRoute
                element={V2Dashboard}
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route
            path="*"
            element={
              isAuthUser === "true" ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default MainRouter;
